<template>
  <div>
    <!-- 区域 -->
    <div
      class="key"
      id="key"
      ref="textEcharts"
      v-loading="loading"
      element-loading-background="rgba(16,164,178 ,0.2)"
    ></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      loading: false,
      textclass: "",
    };
  },
  props: ["analyze"],
  components: {},
  computed: {},
  beforeMount() {},
  mounted() {
    this.Textclass();
  },
  methods: {
    async Textclass() {
      this.loading = true;
      let data = { content: this.analyze };
      const { data: res } = await this.$http.post("/nlpir/deepClassify", data);
      this.loading = false;
      this.textclass = res;
      // 启动echarts
      this.classify_echarts();
    },
    // echarts
    classify_echarts() {
      let classify_echarts = echarts.init(this.$refs.textEcharts);
      var classify = 70;
      var classifierName = this.textclass;
      if (classifierName.indexOf("交通") != -1) {
        classify = 0;
      } else if (classifierName.indexOf("教育") != -1) {
        classify = 10;
      } else if (classifierName.indexOf("经济") != -1) {
        classify = 20;
      } else if (classifierName.indexOf("军事") != -1) {
        classify = 30;
      } else if (classifierName.indexOf("体育") != -1) {
        classify = 40;
      } else if (classifierName.indexOf("艺术") != -1) {
        classify = 50;
      } else if (classifierName.indexOf("政治") != -1) {
        classify = 60;
      }
      if (classifierName.indexOf("其他") != -1) {
        classify = 70;
      }
      var colorSet = {
        color: "#468EFD",
      };
      let option = {
        // backgroundColor: "#0E1327",
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },

        series: [
          {
            name: "内部进度条",
            type: "gauge",
            // center: ["20%", "50%"],
            radius: "60%",
            splitNumber: 10,
            axisLine: {
              lineStyle: {
                color: [
                  [classify / 100, colorSet.color],
                  [1, "#111F42"],
                ],
                width: 8,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            itemStyle: {
              show: false,
            },
            detail: {
              formatter: function (v) {
                switch (v + "") {
                  case "0":
                    return "交通";
                  case "10":
                    return "教育";
                  case "20":
                    return "经济";
                  case "30":
                    return "军事";
                  case "40":
                    return "体育";
                  case "50":
                    return "艺术";
                  case "60":
                    return "政治";
                  case "70":
                    return "文化";
                  case "80":
                    return "医疗";
                  case "90":
                    return "娱乐";
                  case "100":
                    return "其他";
                }
              },
              offsetCenter: [0, 82],
              textStyle: {
                padding: [0, 0, 0, 0],
                fontSize: 18,
                fontWeight: "700",
                color: colorSet.color,
              },
            },
            title: {
              //标题
              show: true,
              offsetCenter: [0, 46], // x, y，单位px
              textStyle: {
                color: "#fff",
                fontSize: 14, //表盘上的标题文字大小
                fontWeight: 400,
                fontFamily: "PingFangSC",
              },
            },
            data: [
              {
                name: "类别",
                value: classify,
              },
            ],
            pointer: {
              show: true,
              length: "75%",
              radius: "20%",
              width: 10, //指针粗细
            },
            animationDuration: 2000,
          },
          {
            name: "外部刻度",
            type: "gauge",
            //  center: ['20%', '50%'],
            radius: "85%",
            min: 0, //最小刻度
            max: 100, //最大刻度
            splitNumber: 10, //刻度数量
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: [[1, "rgba(0,0,0,0)"]],
              },
            }, //仪表盘轴线
            axisLabel: {
              show: true,
              color: "#4d5bd1",
              distance: 25,
              formatter: function (v) {
                switch (v + "") {
                  case "0":
                    return "交通";
                  case "10":
                    return "教育";
                  case "20":
                    return "经济";
                  case "30":
                    return "军事";
                  case "40":
                    return "体育";
                  case "50":
                    return "艺术";
                  case "60":
                    return "政治";
                  case "70":
                    return "文化";
                  case "80":
                    return "医疗";
                  case "90":
                    return "娱乐";
                  case "100":
                    return "其他";
                }
              },
            }, //刻度标签。
            axisTick: {
              show: true,
              splitNumber: 8,
              lineStyle: {
                color: colorSet.color, //用颜色渐变函数不起作用
                width: 1,
              },
              length: -8,
            }, //刻度样式
            splitLine: {
              show: true,
              length: -20,
              lineStyle: {
                color: colorSet.color, //用颜色渐变函数不起作用
              },
            }, //分隔线样式
            detail: {
              show: false,
            },
            pointer: {
              show: false,
            },
          },
        ],
      };

      classify_echarts.setOption(option);
      window.onresize = function () {
        classify_echarts.resize();
      };
    },
  },
  watch: {},
};
</script>
<style scoped>
.key {
  width: 100%;
  height: 359px;
  color: #fff;
  box-sizing: border-box;
  overflow: auto;
}
</style>
